import React from 'react';

function Problem() {
  return (
    <section className="py-16 md:py-20 lg:py-28 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl mb-4 md:mb-6 font-bold text-primary">Late Payments are Stressful. Chasing Them is Worse.</h2>
        <p className="max-w-3xl mx-auto text-primary-light">You delivered great work, sent the invoice (PDF, Word, email)... and now you wait. Checking your bank account, wondering if you need to send <span className="italic text-primary font-medium">that</span> awkward follow-up email again? It wastes time and strains client relationships.</p>
      </div>
    </section>
  );
}

export default Problem; 